// extracted by mini-css-extract-plugin
export default {"color":"#5c6c73","container":"components-Cart-SecureCheckoutLabel-styles-module__container--xM3yE"};